// extracted by mini-css-extract-plugin
export var indeterminate = "_23-5";
export var md = "_23-4";
export var semantic = "_23-6";
export var sm = "_23-3";
export var text = "_23-7";
export var toggleInput = "_23-0";
export var toggleSwitch = "_23-1";
export var xs = "_23-2";